import AccountPaymentMethods from './AccountPaymentMethods';

export default AccountPaymentMethods;
